import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { injectIntl, intlShape } from 'react-intl';

import { TrackedLink, withTracking } from '../../../../xing-tracking';
import trackings from '../../../../trackings';
import styles from './MainItem.css';

const trackingConditions = {
  // eslint-disable-next-line @typescript-eslint/camelcase
  sc_o_PropActionOrigin: false,
};

export const MainItem = ({ intl: { formatMessage }, isActive, meta }) => {
  // When active, use regular icon as fallback if no activeIcon is specified
  const IconElement = isActive
    ? meta.activeIconXdl || meta.iconXdl
    : meta.iconXdl;
  const title = formatMessage({ id: meta.title });

  const ButtonWrapper = meta.href ? TrackedLink : 'div';
  const buttonWrapperProps = meta.href
    ? {
        href: meta.href,
        trackingKey: meta.key,
        conditions: trackingConditions,
      }
    : {
        onClick: () => meta.toggleSidebar(),
      };

  return (
    <li
      className={classNames(styles.navItem, {
        [styles[meta.key]]: Boolean(meta.key),
      })}
    >
      <ButtonWrapper
        {...buttonWrapperProps}
        className={classNames(styles.link, {
          [styles.active]: isActive,
        })}
      >
        {IconElement && (
          <IconElement
            className={classNames(styles.icon, {
              [styles.active]: isActive,
            })}
            aria-label={title}
          />
        )}
        <div>
          <p className={styles.title}>{title}</p>
        </div>
      </ButtonWrapper>
    </li>
  );
};

MainItem.displaName = 'MainItem';

MainItem.propTypes = {
  meta: PropTypes.shape({
    iconXdl: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    activeIconXdl: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    title: PropTypes.string.isRequired,
    key: PropTypes.string,
    href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    toggleSidebar: PropTypes.func,
    activeIcon: PropTypes.element,
  }),
  intl: intlShape,
  isActive: PropTypes.bool,
};

export default injectIntl(withTracking(trackings)(MainItem));
